import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=50e33e3c&scoped=true&lang=pug&"
import script from "./skeleton.vue?vue&type=script&lang=js&"
export * from "./skeleton.vue?vue&type=script&lang=js&"
import style0 from "./skeleton.vue?vue&type=style&index=0&id=50e33e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e33e3c",
  null
  
)

export default component.exports